import { IconDefinition } from '@ant-design/icons-angular';

export const SmallDashOutline: IconDefinition = {
    name: 'small-dash',
    theme: 'outline',
    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z" /></svg>'
}